import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import styles from './Breadcrumbs.module.scss';
import { BreadcrumbItem } from './Breadcrumbs.type';

interface Props {
  items: BreadcrumbItem[];
  enableLastLink?: boolean;
  className?: string;
}

export const Breadcrumbs: FC<Props> = ({ items, className, enableLastLink = false }) =>
  items.length ? (
    <nav
      className={classNames(styles.root, className, { [styles.enableLastLink]: enableLastLink })}
      aria-label="Breadcrumb"
    >
      <ol className={classNames(styles.list, 'c-fs-caption')}>
        {items.map((item, index) => (
          <li className={styles.item} key={item.url}>
            <Link
              href={item.url}
              className={styles.link}
              aria-current={index === items.length - 1 || enableLastLink ? 'page' : undefined}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  ) : null;
